export default __webpack_public_path__ + "static/media/plus_icon.6089b304.svg";